import React, { useEffect, useState } from 'react';
import { buildFileURL } from 'utils/data';
import storage from 'utils/data/storage';
import './index.scss';

const formatSessionTime = (ms) => {
  if (!ms || ms === 0) return null;
  return new Date(ms).toLocaleTimeString("en-US", {
    timeZone: "America/New_York",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};


const UserList = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const recordId = storage.metadata?.id;
    if (!recordId) return;

    const url = buildFileURL('learning_dashboard_data.json', recordId);
    fetch(url, { cache: 'no-store' })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (!data?.users) return;
        const list = Object.values(data.users).map(u => {
          const allSessions = Object.values(u.intIds || {}).flatMap(
            intId => intId.sessions || []
          );
          allSessions.sort((a, b) => a.registeredOn - b.registeredOn);
          return {
            key: u.userKey,
            name: u.name,
            isModerator: u.isModerator,
            color: u.color,
            sessions: allSessions,
          };
        });
        list.sort((a, b) => (a.sessions[0]?.registeredOn || 0) - (b.sessions[0]?.registeredOn || 0));
        setUsers(list);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="users-wrapper">
      <div className="users-list">
        {users.map(user => (
          <div key={user.key} className="user-item">
            <span
              className={`user-avatar ${user.isModerator ? 'moderator' : 'viewer'}`}
              style={{ backgroundColor: user.color }}
            >
              {user.name.charAt(0).toUpperCase()}
            </span>
            <div className="user-info">
              <span className="user-name">{user.name}</span>
              {user.sessions.map((session, i) => (
                <span key={i} className="user-times">
                  {`Joined: ${formatSessionTime(session.registeredOn)}`}
                  {session.leftOn
                    ? ` · Left: ${formatSessionTime(session.leftOn)}`
                    : ''}
                </span>
              ))}
            </div>
          </div>
        ))}
        {users.length === 0 && (
          <div className="users-empty">No participants data</div>
        )}
      </div>
    </div>
  );
};

const areEqual = () => true;

export default React.memo(UserList, areEqual);
